import React from 'react';
import { Canvas } from '@react-three/fiber';
import Scene from './Scene';
import { LANDING_CAMERA } from '../constants/camera';

const CanvasScene = () => (
  <Canvas
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: '#0a0a14',
    }}
    camera={LANDING_CAMERA}
  >
    <Scene />
  </Canvas>
);

export default CanvasScene;
